export const langs = ['zh-cn', 'en-us', 'ja-jp', 'ko-kr']
export const langsSub = [
  { lang: 'en-us', short: 'EN', label: 'English' },
  { lang: 'zh-cn', short: 'ZH-CN', label: '简体中文' },
  // { lang: 'zh-tw', short: 'ZH-TW', label: '繁体中文' },
  // { lang: 'ja-jp', short: 'JA-JP', label: '日本語' },
  // { lang: 'ko-kr', short: 'KO-KR', label: '한국어' },
]
